import { gql } from 'graphql-tag'
import { consumerFields } from '../consumerFields'

export const GET_CONSUMER = gql`
  query getConsumer {
    consumer: getConsumer {
      ...ConsumerFields
    }
  }
  ${consumerFields}
`
